import React, { useContext } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import { Link } from 'react-router-dom';
import UserContext from '../../utils/authorization/UserContext';
import { StatUser } from '../../utils/statApi/UsersApi';
import { bodyContentContainer } from '../../app/common/styles/CommonStyleObjects';
import FullWidthHeader from '../common/headers/FullWidthHeader';
import UserIdentityCard from './UserIdentityCard';
import AssignedRolesSection from './AssignedRolesSection';

const useStyles = makeStyles({
  breadcrumbDivider: {
    color: tokens.colorNeutralForeground3,
    marginLeft: tokens.spacingHorizontalS,
    marginRight: tokens.spacingHorizontalS,
  },
  homeLink: {
    color: tokens.colorBrandForegroundLink,
    textDecorationLine: 'none',
    ':hover': {
      textDecorationLine: 'underline',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXXL,
  },
});

interface UserAccountProps {
  imageUrl?: string | null;
}

const UserAccount = ({ imageUrl }: UserAccountProps): JSX.Element => {
  const user: StatUser = useContext(UserContext);
  const styles = useStyles();

  return (
    <>
      <FullWidthHeader
        breadcrumb={() => (
          <Breadcrumb aria-label="Breadcrumb" size="small">
            <BreadcrumbItem>
              <Link to="/" className={styles.homeLink}>
                Home
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem aria-hidden="true" className={styles.breadcrumbDivider}>
              /
            </BreadcrumbItem>
            <BreadcrumbItem aria-current="page">My account</BreadcrumbItem>
          </Breadcrumb>
        )}
        title={() => <h1>My Account</h1>}
      />
      <div className={mergeClasses(bodyContentContainer, styles.content)}>
        <UserIdentityCard user={user} imageUrl={imageUrl} />
        <AssignedRolesSection roleAssignmentsArray={user.userRoles ?? []} />
      </div>
    </>
  );
};

export default UserAccount;
